// extracted by mini-css-extract-plugin
module.exports = {"content":"facet-FacetGroupDropdown__content--1Ipt3"};